import NodeTable, { FactColumnCell } from './NodeTable';

export default NodeTable;
export { FactColumnCell };
